export enum Permission {
    Operator = "isOperator",
    Admin = "upR_ADMIN",
    Finance = "upR_FINANSE",
    CrmContacts = "upR_SYS_OBSLUGA_KONTAKTOW",
    ContractorDiscountEdit = "upR_SYS_EDYCJA_RABATU_KONTRAHENTA",
}
